export default "__VITE_ASSET__Cb5DNhnC__"